import { useEffect } from 'react';

interface UAScriptProps {
	universalAnalyticsId: string;
}

const LOADER_ID = 'ua-loader';

export function UAScript({ universalAnalyticsId }: UAScriptProps) {
	const useUA = !!universalAnalyticsId?.length;

	useEffect(() => {
		if (!useUA) return;
		if (document.getElementById(LOADER_ID)) return;
		const script = document.createElement('script');
		script.id = LOADER_ID;
		script.async = true;
		script.src = '//www.google-analytics.com/analytics.js';
		document.head.appendChild(script);
	}, [useUA]);

	return useUA ? (
		<script
			id="ua-init"
			dangerouslySetInnerHTML={{
				__html: `
					(function(i,r){
						i['GoogleAnalyticsObject']=r;
						i[r]=i[r]||function(){(i[r].q=i[r].q||[]).push(arguments)};
						i[r].l=1*new Date();
					})(window,'ga');
					ga('create', '${universalAnalyticsId}', 'auto', {'allowLinker': true});
					ga('require', 'displayfeatures');
					ga('send', 'pageview');
				`,
			}}
		/>
	) : null;
}
